__webpack_require__.p = "https://fantasygolf.pgatour.com/";